export enum ProductSubtypeEnum {
    ge = 'ge',
    gx = 'gx',
    snp = 'snp',
    cnv = 'cnv',
    microbre_all = 'microbre_all',
    microrna_advanced = 'microrna_advanced',
    microrna_classic = 'microrna_classic',
    microrna_primary = 'microrna_primary',
    microrna_all = 'microrna_all',
    microrna_array = 'microrna_array'
}
